import { forwardRef, useEffect, useState } from "react";
import { PencilIcon } from "@heroicons/react/24/outline";
import ModalFrame from "../../components/ModalFrame";
import { EditPeerReviewGroupForm } from "./EditPeerReviewGroupForm";
import {
	useLazyEditGroupQuery,
	useEditGroupMutation,
	EditReviewGroupModel,
	ManageReviewGroupRow,
} from "./peerReviewGroupsApiSlice";

interface EditPeerReviewGroupButtonProps {
	row: ManageReviewGroupRow;
	onClick: () => void;
}

export const EditPeerReviewGroupButton = forwardRef<
	HTMLButtonElement,
	EditPeerReviewGroupButtonProps
>((props, ref) => {
	function handleClick() {
		props.onClick();
	}

	return (
		<button
			ref={ref}
			className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
			onClick={handleClick}>
			<PencilIcon className="size-4" />
			<span className="ml-2">Edit</span>
		</button>
	);
});

interface EditPeerReviewGroupDialogProps {
	row: ManageReviewGroupRow;
	isDialogOpen: boolean;
	setAlert: (message: string) => void;
	onClose: () => void;
}

export function EditPeerReviewGroupDialog(props: EditPeerReviewGroupDialogProps) {
	const [editGroupData, setEditGroupData] = useState<EditReviewGroupModel>();
	const [callGetEditGroup] = useLazyEditGroupQuery();
	const [callPostEditGroup] = useEditGroupMutation();

	useEffect(() => {
		if (props.isDialogOpen) {
			callGetEditGroup(props.row.id)
				.unwrap()
				.then((result) => {
					setEditGroupData(result);
				})
				.catch((error: any) => {
					console.log(error);
				});
		}
	}, [props.isDialogOpen]);

	function handleSubmit(model: EditReviewGroupModel) {
		var errorMessage = "";
		callPostEditGroup(model)
			.unwrap()
			.then(() => {
				props.onClose();
			})
			.catch((error: any) => {
				console.log(error);
				errorMessage = error.data;
			});
		return errorMessage;
	}

	return (
		editGroupData && (
			<ModalFrame
				open={props.isDialogOpen}
				title="Edit Review Group"
				overflow="overflow-visible"
				onClose={() => props.onClose()}>
				<EditPeerReviewGroupForm
					initialGroupData={editGroupData}
					submitLabel="Save Group"
					onSubmit={handleSubmit}
					onClose={props.onClose}
				/>
			</ModalFrame>
		)
	);
}
